import { render, staticRenderFns } from "./SealingEquipment.vue?vue&type=template&id=20bdd27c&scoped=true"
import script from "./SealingEquipment.vue?vue&type=script&lang=js"
export * from "./SealingEquipment.vue?vue&type=script&lang=js"
import style0 from "./SealingEquipment.vue?vue&type=style&index=0&id=20bdd27c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bdd27c",
  null
  
)

export default component.exports